import { render, staticRenderFns } from "./fix.vue?vue&type=template&id=79a38543&scoped=true"
import script from "./fix.vue?vue&type=script&lang=js"
export * from "./fix.vue?vue&type=script&lang=js"
import style0 from "./fix.vue?vue&type=style&index=0&id=79a38543&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a38543",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79a38543')) {
      api.createRecord('79a38543', component.options)
    } else {
      api.reload('79a38543', component.options)
    }
    module.hot.accept("./fix.vue?vue&type=template&id=79a38543&scoped=true", function () {
      api.rerender('79a38543', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/exchangeRate/fix.vue"
export default component.exports